<template>
  <div>
    <MenuInterpretacionesLider />
    <!--  Lider PHD  -->
    <div class="box">
      <h1
        v-if="nameLider"
        class="is-size-3 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
      >
        Líder PHD - {{ nameLider !== "" ? nameLider : "" }}
      </h1>
      <div class="columns">
        <div :class="['column', { 'is-7': !generalContext.status }]">
          <div v-if="dataLider.colaboradores">
            <!--      V. Desktop      -->
            <table class="table-info is-hidden-mobile" style="width: 100%">
              <tr>
                <td colspan="3">
                  <h1
                    v-if="nameLider === ''"
                    class="is-size-3 is-black has-text-right-desktop has-text-centered-mobile  has-text-weight-bold"
                  >
                    Líder PHD
                  </h1>
                </td>
              </tr>
              <tr>
                <td style="width: 10%;" class="has-text-right" colspan="2">
                  <span class="is-size-6"
                    ><div style="padding-top: 15px">Colaborador</div></span
                  >
                </td>
                <td style="width: 4%" class="is-hidden-mobile"></td>
                <td style="width: 86%;" class="is-hidden-mobile">
                  <GraphBullet
                    class="div-bullet"
                    :dataGraph="createdGraph('colaboradores', 'liderT')"
                    :cambio="dataLider.cambio"
                  />
                </td>
              </tr>
              <tr>
                <td style="width: 10%;" class="has-text-right" colspan="2">
                  <span class="is-size-6">Autoevaluación</span>
                </td>
                <td style="width: 4%" class="is-hidden-mobile"></td>
                <td style="width: 86%" class="is-hidden-mobile">
                  <GraphBullet
                    class="div-bullet"
                    style="margin-top: -15px"
                    :dataGraph="createdGraph('autoevaluacion', 'liderT')"
                    :cambio="dataLider.cambio"
                  />
                </td>
              </tr>
              <tr>
                <td style="width: 10%;">
                  <span class="is-size-6 has-text-right">Autoconciencia</span>
                </td>
                <td class="has-text-left">
                  <strong class="is-size-6 autoc-rango">{{
                    rangoAuto("liderT")
                  }}</strong>
                </td>
              </tr>
            </table>

            <!--      V. Mobile      -->
            <div class="is-hidden-desktop">
              <h1
                class="item-lider is-size-3 is-black has-text-right-desktop has-text-centered-mobile  has-text-weight-bold"
              >
                Líder PHD
              </h1>
              <div class="item-lider has-text-centered">
                <span class="is-size-6"><div>Colaborador</div></span>
              </div>
              <div class="item-lider">
                <GraphBullet
                  class="div-bullet"
                  style="margin-top: -15px"
                  :dataGraph="createdGraph('colaboradores', 'liderT')"
                  :cambio="dataLider.cambio"
                />
              </div>
              <div class="item-lider has-text-centered">
                <span class="is-size-6">Autoevaluación</span>
              </div>
              <div class="item-lider">
                <GraphBullet
                  class="div-bullet"
                  style="margin-top: -15px"
                  :dataGraph="createdGraph('autoevaluacion', 'liderT')"
                  :cambio="dataLider.cambio"
                />
              </div>
              <div class="item-lider has-text-centered"></div>
              <span class="is-size-6"
                >Autoconciencia<strong class="is-size-6 autoc-rango">{{
                  rangoAuto("cond")
                }}</strong></span
              >
              <hr />
            </div>
          </div>
        </div>
        <div
          v-if="!generalContext.status"
          class="column is-5"
          style="margin-top: auto; margin-bottom: auto"
        >
          <div
            class="tags has-addons"
            style="margin-bottom: 0 !important;"
            v-if="dataLider.colaboradores"
          >
            <span
              class="tag is-medium"
              style="width: 100%"
              :class="`rango${dataLider.colaboradores.liderT.r}`"
            >
              {{ nombresRangos[dataLider.colaboradores.liderT.r] }}
            </span>
          </div>
          <span v-if="dataLider.colaboradores" class="is-size-7">{{
            calificaciones.general[dataLider.colaboradores.liderT.r]
          }}</span>
          <div
            class="is-flex"
            style="margin-top: 0.5rem"
            v-if="dataLider.colaboradores"
          >
            <span class="tag is-grey has-text-weight-bold"
              >Meta a proponerse en puntos
              {{ metas[dataLider.colaboradores.liderT.e.toFixed(0)] }}</span
            >
          </div>
        </div>
        <Transition name="Fade">
          <div
            v-if="generalContext.status"
            class="column is-2"
            style="margin: auto !important;"
          >
            <div class="ranking ranking-only-icon">
              <img
                src="@/assets/icons/ranking-linear.svg"
                alt="rankingIconCL7"
                width="60"
              />
              <div class="info">
                <span class="subtitle-ranking">
                  Entre
                  <strong>{{ generalContext.headers.leaders || 0 }}</strong>
                  Líderes
                </span>
              </div>
            </div>
          </div>
        </Transition>
        <Transition name="Fade">
          <div class="column column-graph" v-if="generalContext.status">
            <h2
              class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile has-text-weight-bold"
            >
              Distribución de líderes
            </h2>
            <GraphChartJs :config="createdLineContext('liderT')" />
          </div>
        </Transition>
      </div>
    </div>
    <hr style="height: 6px !important;" />
    <div class="box">
      <!--  Gestión Conocimiento  -->
      <div style="margin-top: 30px">
        <div class="columns">
          <div :class="['column', { 'is-7': !generalContext.status }]">
            <div v-if="dataLider.colaboradores">
              <!--      V. Desktop      -->
              <table class="table-info is-hidden-mobile" style="width: 100%">
                <tr>
                  <td colspan="4">
                    <div class="is-flex">
                      <i
                        v-if="estructura.cond.length > 0"
                        v-on:click="showMore('cond')"
                        class="material-icons has-text-dark"
                        style="cursor: pointer"
                        >{{
                          show.cond
                            ? "remove_circle_outline"
                            : "add_circle_outline"
                        }}</i
                      >
                      <h1
                        class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                      >
                        Gestión Conocimiento
                      </h1>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;" class="has-text-right" colspan="2">
                    <span class="is-size-6"
                      ><div style="padding-top: 15px">Colaborador</div></span
                    >
                  </td>
                  <td style="width: 4%" class="is-hidden-mobile"></td>
                  <td style="width: 86%;" class="is-hidden-mobile">
                    <GraphBullet
                      class="div-bullet"
                      :dataGraph="createdGraph('colaboradores', 'cond')"
                      :cambio="dataLider.cambio"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;" class="has-text-right" colspan="2">
                    <span class="is-size-6">Autoevaluación</span>
                  </td>
                  <td style="width: 4%" class="is-hidden-mobile"></td>
                  <td style="width: 86%" class="is-hidden-mobile">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('autoevaluacion', 'cond')"
                      :cambio="dataLider.cambio"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;">
                    <span class="is-size-6 has-text-right">Autoconciencia</span>
                  </td>
                  <td class="has-text-left">
                    <strong class="is-size-6 autoc-rango">{{
                      rangoAuto("cond")
                    }}</strong>
                  </td>
                </tr>
              </table>

              <!--      V. Mobile      -->
              <div class="is-hidden-desktop">
                <div class="is-flex">
                  <i
                    v-if="estructura.cond.length > 0"
                    v-on:click="showMore('cond')"
                    class="material-icons has-text-dark"
                    style="cursor: pointer"
                    >{{
                      show.cond ? "remove_circle_outline" : "add_circle_outline"
                    }}</i
                  >
                  <h1
                    class="item-lider is-size-5 is-black has-text-right-desktop has-text-centered-mobile  has-text-weight-bold"
                  >
                    Gestión Conocimiento
                  </h1>
                </div>
                <div class="item-lider has-text-centered">
                  <span class="is-size-6"><div>Colaborador</div></span>
                </div>
                <div class="item-lider">
                  <GraphBullet
                    class="div-bullet"
                    style="margin-top: -15px"
                    :dataGraph="createdGraph('colaboradores', 'cond')"
                    :cambio="dataLider.cambio"
                  />
                </div>
                <div class="item-lider has-text-centered">
                  <span class="is-size-6">Autoevaluación</span>
                </div>
                <div class="item-lider">
                  <GraphBullet
                    class="div-bullet"
                    style="margin-top: -15px"
                    :dataGraph="createdGraph('autoevaluacion', 'cond')"
                    :cambio="dataLider.cambio"
                  />
                </div>
                <div class="item-lider has-text-centered"></div>
                <span class="is-size-6"
                  >Autoconciencia<strong class="is-size-6 autoc-rango">{{
                    rangoAuto("cond")
                  }}</strong></span
                >
                <hr />
              </div>
            </div>
          </div>
          <div
            v-if="!generalContext.status"
            class="column is-5"
            style="margin-top: auto; margin-bottom: auto"
          >
            <div
              class="tags has-addons"
              style="margin-bottom: 0 !important;"
              v-if="dataLider.colaboradores"
            >
              <span
                class="tag is-medium"
                style="width: 100%"
                :class="`rango${dataLider.colaboradores.cond.r}`"
              >
                {{ nombresRangos[dataLider.colaboradores.cond.r] }}
              </span>
            </div>
            <span v-if="dataLider.colaboradores" class="is-size-7">{{
              calificaciones.cond[dataLider.colaboradores.cond.r]
            }}</span>
            <div
              class="is-flex"
              style="margin-top: 0.5rem"
              v-if="dataLider.colaboradores"
            >
              <span class="tag is-grey has-text-weight-bold"
                >Meta a proponerse en puntos
                {{ metas[dataLider.colaboradores.cond.e.toFixed(0)] }}</span
              >
            </div>
          </div>
          <Transition name="Fade">
            <div
              v-if="generalContext.status"
              class="column is-2"
              style="margin: auto !important;"
            >
              <div class="ranking">
                <div
                  class="info"
                  style="width: 100%;"
                  v-tooltip.bottom="
                    `Posición actual frente a ${generalContext.headers
                      .clients || 0} de empresas`
                  "
                >
                  <span class="title-ranking card-position">
                    {{ getPositionVar("cond") }}
                  </span>
                </div>
              </div>
            </div>
          </Transition>
          <Transition name="Fade">
            <div v-if="generalContext.status" class="column column-graph">
              <GraphChartJs :config="createdLineContext('cond')" />
            </div>
          </Transition>
        </div>
        <div v-if="show.cond" class="sub-items">
          <br />
          <div
            class="columns"
            v-for="(item, index) in estructura.cond"
            :key="index"
          >
            <div :class="['column', { 'is-7': !generalContext.status }]">
              <div v-if="dataLider.colaboradores">
                <!--      V. Desktop      -->
                <table class="table-info is-hidden-mobile" style="width: 100%">
                  <tr>
                    <td colspan="4">
                      <div class="is-flex">
                        <h1
                          class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                        >
                          {{ nombres[item] }}
                        </h1>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;" class="has-text-right" colspan="2">
                      <span class="is-size-6"
                        ><div style="padding-top: 15px">Colaborador</div></span
                      >
                    </td>
                    <td style="width: 4%" class="is-hidden-mobile"></td>
                    <td style="width: 86%;" class="is-hidden-mobile">
                      <GraphBullet
                        class="div-bullet"
                        :dataGraph="createdGraph('colaboradores', item)"
                        :cambio="dataLider.cambio"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;" class="has-text-right" colspan="2">
                      <span class="is-size-6">Autoevaluación</span>
                    </td>
                    <td style="width: 4%" class="is-hidden-mobile"></td>
                    <td style="width: 86%" class="is-hidden-mobile">
                      <GraphBullet
                        class="div-bullet"
                        style="margin-top: -15px"
                        :dataGraph="createdGraph('autoevaluacion', item)"
                        :cambio="dataLider.cambio"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">
                      <span class="is-size-6 has-text-right"
                        >Autoconciencia</span
                      >
                    </td>
                    <td class="has-text-left">
                      <strong class="is-size-6 autoc-rango">{{
                        rangoAuto(item)
                      }}</strong>
                    </td>
                  </tr>
                </table>

                <!--      V. Mobile      -->
                <div class="is-hidden-desktop">
                  <div class="is-flex">
                    <h1
                      class="item-lider is-size-5 is-black has-text-right-desktop has-text-centered-mobile  has-text-weight-bold"
                    >
                      {{ nombres[item] }}
                    </h1>
                  </div>
                  <div class="item-lider has-text-centered">
                    <span class="is-size-6"><div>Colaborador</div></span>
                  </div>
                  <div class="item-lider">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('colaboradores', item)"
                      :cambio="dataLider.cambio"
                    />
                  </div>
                  <div class="item-lider has-text-centered">
                    <span class="is-size-6">Autoevaluación</span>
                  </div>
                  <div class="item-lider">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('autoevaluacion', item)"
                      :cambio="dataLider.cambio"
                    />
                  </div>
                  <div class="item-lider has-text-centered"></div>
                  <span class="is-size-6"
                    >Autoconciencia<strong class="is-size-6 autoc-rango">{{
                      rangoAuto(item)
                    }}</strong></span
                  >
                  <hr />
                </div>
              </div>
            </div>
            <div
              v-if="!generalContext.status"
              class="column is-5"
              style="margin-top: auto; margin-bottom: auto"
            >
              <div
                class="tags has-addons"
                style="margin-bottom: 0 !important;"
                v-if="dataLider.colaboradores"
              >
                <span
                  class="tag is-medium"
                  style="width: 100%"
                  :class="`rango${dataLider.colaboradores[item].r}`"
                >
                  {{ nombresRangos[dataLider.colaboradores[item].r] }}
                </span>
              </div>
              <span v-if="dataLider.colaboradores" class="is-size-7">{{
                calificaciones[item][dataLider.colaboradores[item].r]
              }}</span>
              <div
                class="is-flex"
                style="margin-top: 0.5rem"
                v-if="dataLider.colaboradores"
              >
                <span class="tag is-grey has-text-weight-bold"
                  >Meta a proponerse en puntos
                  {{ metas[dataLider.colaboradores[item].e.toFixed(0)] }}</span
                >
              </div>
            </div>
            <Transition name="Fade">
              <div
                v-if="generalContext.status"
                class="column is-2"
                style="margin: auto !important;"
              >
                <div class="ranking">
                  <div
                    class="info"
                    style="width: 100%;"
                    v-tooltip.bottom="
                      `Posición actual frente a ${generalContext.headers
                        .clients || 0} de empresas`
                    "
                  >
                    <span class="title-ranking card-position">
                      {{ getPositionVar(item) }}
                    </span>
                  </div>
                </div>
              </div>
            </Transition>
            <Transition name="Fade">
              <div v-if="generalContext.status" class="column column-graph">
                <GraphChartJs :config="createdLineContext(item)" />
              </div>
            </Transition>
          </div>
        </div>
      </div>
      <hr />
      <!--  Gestión Resultados  -->
      <div style="margin-top: 30px">
        <div class="columns">
          <div :class="['column', { 'is-7': !generalContext.status }]">
            <div v-if="dataLider.colaboradores">
              <!--      V. Desktop      -->
              <table class="table-info is-hidden-mobile" style="width: 100%">
                <tr>
                  <td colspan="4">
                    <div class="is-flex">
                      <i
                        v-if="estructura.resuld.length > 0"
                        v-on:click="showMore('resuld')"
                        class="material-icons has-text-dark"
                        style="cursor: pointer"
                        >{{
                          show.resuld
                            ? "remove_circle_outline"
                            : "add_circle_outline"
                        }}</i
                      >
                      <h1
                        class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                      >
                        Gestión Resultados
                      </h1>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;" class="has-text-right" colspan="2">
                    <span class="is-size-6"
                      ><div style="padding-top: 15px">Colaborador</div></span
                    >
                  </td>
                  <td style="width: 4%" class="is-hidden-mobile"></td>
                  <td style="width: 86%;" class="is-hidden-mobile">
                    <GraphBullet
                      class="div-bullet"
                      :dataGraph="createdGraph('colaboradores', 'resuld')"
                      :cambio="dataLider.cambio"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;" class="has-text-right" colspan="2">
                    <span class="is-size-6">Autoevaluación</span>
                  </td>
                  <td style="width: 4%" class="is-hidden-mobile"></td>
                  <td style="width: 86%" class="is-hidden-mobile">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('autoevaluacion', 'resuld')"
                      :cambio="dataLider.cambio"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;">
                    <span class="is-size-6 has-text-right">Autoconciencia</span>
                  </td>
                  <td class="has-text-left">
                    <strong class="is-size-6 autoc-rango">{{
                      rangoAuto("resuld")
                    }}</strong>
                  </td>
                </tr>
              </table>

              <!--      V. Mobile      -->
              <div class="is-hidden-desktop">
                <div class="is-flex">
                  <i
                    v-if="estructura.resuld.length > 0"
                    v-on:click="showMore('resuld')"
                    class="material-icons has-text-dark"
                    style="cursor: pointer"
                    >{{
                      show.resuld
                        ? "remove_circle_outline"
                        : "add_circle_outline"
                    }}</i
                  >
                  <h1
                    class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                  >
                    Gestión Resultados
                  </h1>
                </div>
                <div class="item-lider has-text-centered">
                  <span class="is-size-6"><div>Colaborador</div></span>
                </div>
                <div class="item-lider">
                  <GraphBullet
                    class="div-bullet"
                    style="margin-top: -15px"
                    :dataGraph="createdGraph('colaboradores', 'resuld')"
                    :cambio="dataLider.cambio"
                  />
                </div>
                <div class="item-lider has-text-centered">
                  <span class="is-size-6">Autoevaluación</span>
                </div>
                <div class="item-lider">
                  <GraphBullet
                    class="div-bullet"
                    style="margin-top: -15px"
                    :dataGraph="createdGraph('autoevaluacion', 'resuld')"
                    :cambio="dataLider.cambio"
                  />
                </div>
                <div class="item-lider has-text-centered"></div>
                <span class="is-size-6"
                  >Autoconciencia<strong class="is-size-6 autoc-rango">{{
                    rangoAuto("resuld")
                  }}</strong></span
                >
                <hr />
              </div>
            </div>
          </div>
          <div
            v-if="!generalContext.status"
            class="column is-5"
            style="margin-top: auto; margin-bottom: auto"
          >
            <div
              class="tags has-addons"
              style="margin-bottom: 0 !important;"
              v-if="dataLider.colaboradores"
            >
              <span
                class="tag is-medium"
                style="width: 100%"
                :class="`rango${dataLider.colaboradores.resuld.r}`"
              >
                {{ nombresRangos[dataLider.colaboradores.resuld.r] }}
              </span>
            </div>
            <span v-if="dataLider.colaboradores" class="is-size-7">{{
              calificaciones.resuld[dataLider.colaboradores.resuld.r]
            }}</span>
            <div
              class="is-flex"
              style="margin-top: 0.5rem"
              v-if="dataLider.colaboradores"
            >
              <span class="tag is-grey has-text-weight-bold"
                >Meta a proponerse en puntos
                {{ metas[dataLider.colaboradores.resuld.e.toFixed(0)] }}</span
              >
            </div>
          </div>
          <Transition name="Fade">
            <div
              v-if="generalContext.status"
              class="column is-2"
              style="margin: auto !important;"
            >
              <div class="ranking">
                <div
                  class="info"
                  style="width: 100%;"
                  v-tooltip.bottom="
                    `Posición actual frente a ${generalContext.headers
                      .clients || 0} de empresas`
                  "
                >
                  <span class="title-ranking card-position">
                    {{ getPositionVar("resuld") }}
                  </span>
                </div>
              </div>
            </div>
          </Transition>
          <Transition name="Fade">
            <div v-if="generalContext.status" class="column column-graph">
              <GraphChartJs :config="createdLineContext('resuld')" />
            </div>
          </Transition>
        </div>
        <div v-if="show.resuld" class="sub-items">
          <br />
          <div
            class="columns"
            v-for="(item, index) in estructura.resuld"
            :key="index"
          >
            <div :class="['column', { 'is-7': !generalContext.status }]">
              <div v-if="dataLider.colaboradores">
                <!--      V. Desktop      -->
                <table class="table-info is-hidden-mobile" style="width: 100%">
                  <tr>
                    <td colspan="4">
                      <div class="is-flex">
                        <h1
                          class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                        >
                          {{ nombres[item] }}
                        </h1>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;" class="has-text-right" colspan="2">
                      <span class="is-size-6"
                        ><div style="padding-top: 15px">Colaborador</div></span
                      >
                    </td>
                    <td style="width: 4%" class="is-hidden-mobile"></td>
                    <td style="width: 86%;" class="is-hidden-mobile">
                      <GraphBullet
                        class="div-bullet"
                        :dataGraph="createdGraph('colaboradores', item)"
                        :cambio="dataLider.cambio"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;" class="has-text-right" colspan="2">
                      <span class="is-size-6">Autoevaluación</span>
                    </td>
                    <td style="width: 4%" class="is-hidden-mobile"></td>
                    <td style="width: 86%" class="is-hidden-mobile">
                      <GraphBullet
                        class="div-bullet"
                        style="margin-top: -15px"
                        :dataGraph="createdGraph('autoevaluacion', item)"
                        :cambio="dataLider.cambio"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">
                      <span class="is-size-6 has-text-right"
                        >Autoconciencia</span
                      >
                    </td>
                    <td class="has-text-left">
                      <strong class="is-size-6 autoc-rango">{{
                        rangoAuto(item)
                      }}</strong>
                    </td>
                  </tr>
                </table>

                <!--      V. Mobile      -->
                <div class="is-hidden-desktop">
                  <div class="is-flex">
                    <h1
                      class="item-lider is-size-5 is-black has-text-right-desktop has-text-centered-mobile  has-text-weight-bold"
                    >
                      {{ nombres[item] }}
                    </h1>
                  </div>
                  <div class="item-lider has-text-centered">
                    <span class="is-size-6"><div>Colaborador</div></span>
                  </div>
                  <div class="item-lider">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('colaboradores', item)"
                      :cambio="dataLider.cambio"
                    />
                  </div>
                  <div class="item-lider has-text-centered">
                    <span class="is-size-6">Autoevaluación</span>
                  </div>
                  <div class="item-lider">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('autoevaluacion', item)"
                      :cambio="dataLider.cambio"
                    />
                  </div>
                  <div class="item-lider has-text-centered"></div>
                  <span class="is-size-6"
                    >Autoconciencia<strong class="is-size-6 autoc-rango">{{
                      rangoAuto(item)
                    }}</strong></span
                  >
                  <hr />
                </div>
              </div>
            </div>
            <div
              v-if="!generalContext.status"
              class="column is-5"
              style="margin-top: auto; margin-bottom: auto"
            >
              <div
                class="tags has-addons"
                style="margin-bottom: 0 !important;"
                v-if="dataLider.colaboradores"
              >
                <span
                  class="tag is-medium"
                  style="width: 100%"
                  :class="`rango${dataLider.colaboradores[item].r}`"
                >
                  {{ nombresRangos[dataLider.colaboradores[item].r] }}
                </span>
              </div>
              <span v-if="dataLider.colaboradores" class="is-size-7">{{
                calificaciones[item][dataLider.colaboradores[item].r]
              }}</span>
              <div
                class="is-flex"
                style="margin-top: 0.5rem"
                v-if="dataLider.colaboradores"
              >
                <span class="tag is-grey has-text-weight-bold"
                  >Meta a proponerse en puntos
                  {{ metas[dataLider.colaboradores[item].e.toFixed(0)] }}</span
                >
              </div>
            </div>
            <Transition name="Fade">
              <div
                v-if="generalContext.status"
                class="column is-2"
                style="margin: auto !important;"
              >
                <div class="ranking">
                  <div
                    class="info"
                    style="width: 100%;"
                    v-tooltip.bottom="
                      `Posición actual frente a ${generalContext.headers
                        .clients || 0} de empresas`
                    "
                  >
                    <span class="title-ranking card-position">
                      {{ getPositionVar(item) }}
                    </span>
                  </div>
                </div>
              </div>
            </Transition>
            <Transition name="Fade">
              <div v-if="generalContext.status" class="column column-graph">
                <GraphChartJs :config="createdLineContext(item)" />
              </div>
            </Transition>
          </div>
        </div>
      </div>
      <hr />
      <!--  Gestión Sí mismo  -->
      <div style="margin-top: 30px">
        <div class="columns">
          <div :class="['column', { 'is-7': !generalContext.status }]">
            <div v-if="dataLider.colaboradores">
              <!--      V. Desktop      -->
              <table class="table-info is-hidden-mobile" style="width: 100%">
                <tr>
                  <td colspan="4">
                    <div class="is-flex">
                      <i
                        v-if="estructura.dsmd.length > 0"
                        v-on:click="showMore('dsmd')"
                        class="material-icons has-text-dark"
                        style="cursor: pointer"
                        >{{
                          show.dsmd
                            ? "remove_circle_outline"
                            : "add_circle_outline"
                        }}</i
                      >
                      <h1
                        class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                      >
                        Gestión Sí mismo
                      </h1>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;" class="has-text-right" colspan="2">
                    <span class="is-size-6"
                      ><div style="padding-top: 15px">Colaborador</div></span
                    >
                  </td>
                  <td style="width: 4%" class="is-hidden-mobile"></td>
                  <td style="width: 86%;" class="is-hidden-mobile">
                    <GraphBullet
                      class="div-bullet"
                      :dataGraph="createdGraph('colaboradores', 'dsmd')"
                      :cambio="dataLider.cambio"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;" class="has-text-right" colspan="2">
                    <span class="is-size-6">Autoevaluación</span>
                  </td>
                  <td style="width: 4%" class="is-hidden-mobile"></td>
                  <td style="width: 86%" class="is-hidden-mobile">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('autoevaluacion', 'dsmd')"
                      :cambio="dataLider.cambio"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;">
                    <span class="is-size-6 has-text-right">Autoconciencia</span>
                  </td>
                  <td class="has-text-left">
                    <strong class="is-size-6 autoc-rango">{{
                      rangoAuto("dsmd")
                    }}</strong>
                  </td>
                </tr>
              </table>

              <!--      V. Mobile      -->
              <div class="is-hidden-desktop">
                <div class="is-flex">
                  <i
                    v-if="estructura.dsmd.length > 0"
                    v-on:click="showMore('dsmd')"
                    class="material-icons has-text-dark"
                    style="cursor: pointer"
                    >{{
                      show.dsmd ? "remove_circle_outline" : "add_circle_outline"
                    }}</i
                  >
                  <h1
                    class="item-lider is-size-5 is-black has-text-right-desktop has-text-centered-mobile  has-text-weight-bold"
                  >
                    Gestión Sí mismo
                  </h1>
                </div>
                <div class="item-lider has-text-centered">
                  <span class="is-size-6"><div>Colaborador</div></span>
                </div>
                <div class="item-lider">
                  <GraphBullet
                    class="div-bullet"
                    style="margin-top: -15px"
                    :dataGraph="createdGraph('colaboradores', 'dsmd')"
                    :cambio="dataLider.cambio"
                  />
                </div>
                <div class="item-lider has-text-centered">
                  <span class="is-size-6">Autoevaluación</span>
                </div>
                <div class="item-lider">
                  <GraphBullet
                    class="div-bullet"
                    style="margin-top: -15px"
                    :dataGraph="createdGraph('autoevaluacion', 'dsmd')"
                    :cambio="dataLider.cambio"
                  />
                </div>
                <div class="item-lider has-text-centered"></div>
                <span class="is-size-6"
                  >Autoconciencia<strong class="is-size-6 autoc-rango">{{
                    rangoAuto("dsmd")
                  }}</strong></span
                >
                <hr />
              </div>
            </div>
          </div>
          <div
            v-if="!generalContext.status"
            class="column is-5"
            style="margin-top: auto; margin-bottom: auto"
          >
            <div
              class="tags has-addons"
              style="margin-bottom: 0 !important;"
              v-if="dataLider.colaboradores"
            >
              <span
                class="tag is-medium"
                style="width: 100%"
                :class="`rango${dataLider.colaboradores.dsmd.r}`"
              >
                {{ nombresRangos[dataLider.colaboradores.dsmd.r] }}
              </span>
            </div>
            <span v-if="dataLider.colaboradores" class="is-size-7">{{
              calificaciones.dsmd[dataLider.colaboradores.dsmd.r]
            }}</span>
            <div
              class="is-flex"
              style="margin-top: 0.5rem"
              v-if="dataLider.colaboradores"
            >
              <span class="tag is-grey has-text-weight-bold"
                >Meta a proponerse en puntos
                {{ metas[dataLider.colaboradores.dsmd.e.toFixed(0)] }}</span
              >
            </div>
          </div>
          <Transition name="Fade">
            <div
              v-if="generalContext.status"
              class="column is-2"
              style="margin: auto !important;"
            >
              <div class="ranking">
                <div
                  class="info"
                  style="width: 100%;"
                  v-tooltip.bottom="
                    `Posición actual frente a ${generalContext.headers
                      .clients || 0} de empresas`
                  "
                >
                  <span class="title-ranking card-position">
                    {{ getPositionVar("dsmd") }}
                  </span>
                </div>
              </div>
            </div>
          </Transition>
          <Transition name="Fade">
            <div v-if="generalContext.status" class="column column-graph">
              <GraphChartJs :config="createdLineContext('dsmd')" />
            </div>
          </Transition>
        </div>
        <div v-if="show.dsmd" class="sub-items">
          <br />
          <div
            class="columns"
            v-for="(item, index) in estructura.dsmd"
            :key="index"
          >
            <div :class="['column', { 'is-7': !generalContext.status }]">
              <div v-if="dataLider.colaboradores">
                <!--      V. Desktop      -->
                <table class="table-info is-hidden-mobile" style="width: 100%">
                  <tr>
                    <td colspan="4">
                      <div class="is-flex">
                        <h1
                          class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                        >
                          {{ nombres[item] }}
                        </h1>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;" class="has-text-right" colspan="2">
                      <span class="is-size-6"
                        ><div style="padding-top: 15px">Colaborador</div></span
                      >
                    </td>
                    <td style="width: 4%" class="is-hidden-mobile"></td>
                    <td style="width: 86%;" class="is-hidden-mobile">
                      <GraphBullet
                        class="div-bullet"
                        :dataGraph="createdGraph('colaboradores', item)"
                        :cambio="dataLider.cambio"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;" class="has-text-right" colspan="2">
                      <span class="is-size-6">Autoevaluación</span>
                    </td>
                    <td style="width: 4%" class="is-hidden-mobile"></td>
                    <td style="width: 86%" class="is-hidden-mobile">
                      <GraphBullet
                        class="div-bullet"
                        style="margin-top: -15px"
                        :dataGraph="createdGraph('autoevaluacion', item)"
                        :cambio="dataLider.cambio"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">
                      <span class="is-size-6 has-text-right"
                        >Autoconciencia</span
                      >
                    </td>
                    <td class="has-text-left">
                      <strong class="is-size-6 autoc-rango">{{
                        rangoAuto(item)
                      }}</strong>
                    </td>
                  </tr>
                </table>

                <!--      V. Mobile      -->
                <div class="is-hidden-desktop">
                  <div class="is-flex">
                    <h1
                      class="item-lider is-size-5 is-black has-text-right-desktop has-text-centered-mobile  has-text-weight-bold"
                    >
                      {{ nombres[item] }}
                    </h1>
                  </div>
                  <div class="item-lider has-text-centered">
                    <span class="is-size-6"><div>Colaborador</div></span>
                  </div>
                  <div class="item-lider">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('colaboradores', item)"
                      :cambio="dataLider.cambio"
                    />
                  </div>
                  <div class="item-lider has-text-centered">
                    <span class="is-size-6">Autoevaluación</span>
                  </div>
                  <div class="item-lider">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('autoevaluacion', item)"
                      :cambio="dataLider.cambio"
                    />
                  </div>
                  <div class="item-lider has-text-centered"></div>
                  <span class="is-size-6"
                    >Autoconciencia<strong class="is-size-6 autoc-rango">{{
                      rangoAuto(item)
                    }}</strong></span
                  >
                  <hr />
                </div>
              </div>
            </div>
            <div
              v-if="!generalContext.status"
              class="column is-5"
              style="margin-top: auto; margin-bottom: auto"
            >
              <div
                class="tags has-addons"
                style="margin-bottom: 0 !important;"
                v-if="dataLider.colaboradores"
              >
                <span
                  class="tag is-medium"
                  style="width: 100%"
                  :class="`rango${dataLider.colaboradores[item].r}`"
                >
                  {{ nombresRangos[dataLider.colaboradores[item].r] }}
                </span>
              </div>
              <span v-if="dataLider.colaboradores" class="is-size-7">{{
                calificaciones[item][dataLider.colaboradores[item].r]
              }}</span>
              <div
                class="is-flex"
                style="margin-top: 0.5rem"
                v-if="dataLider.colaboradores"
              >
                <span class="tag is-grey has-text-weight-bold"
                  >Meta a proponerse en puntos
                  {{ metas[dataLider.colaboradores[item].e.toFixed(0)] }}</span
                >
              </div>
            </div>
            <Transition name="Fade">
              <div
                v-if="generalContext.status"
                class="column is-2"
                style="margin: auto !important;"
              >
                <div class="ranking">
                  <div
                    class="info"
                    style="width: 100%;"
                    v-tooltip.bottom="
                      `Posición actual frente a ${generalContext.headers
                        .clients || 0} de empresas`
                    "
                  >
                    <span class="title-ranking card-position">
                      {{ getPositionVar(item) }}
                    </span>
                  </div>
                </div>
              </div>
            </Transition>
            <Transition name="Fade">
              <div v-if="generalContext.status" class="column column-graph">
                <GraphChartJs :config="createdLineContext(item)" />
              </div>
            </Transition>
          </div>
        </div>
      </div>
      <hr />
      <!--  Gestión Personas  -->
      <div style="margin-top: 30px">
        <div class="columns">
          <div :class="['column', { 'is-7': !generalContext.status }]">
            <div v-if="dataLider.colaboradores">
              <!--      V. Desktop      -->
              <table class="table-info is-hidden-mobile" style="width: 100%">
                <tr>
                  <td colspan="4">
                    <div class="is-flex">
                      <i
                        v-if="estructura.gperd.length > 0"
                        v-on:click="showMore('gperd')"
                        class="material-icons has-text-dark"
                        style="cursor: pointer"
                        >{{
                          show.gperd
                            ? "remove_circle_outline"
                            : "add_circle_outline"
                        }}</i
                      >
                      <h1
                        class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                      >
                        Gestión Personas
                      </h1>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;" class="has-text-right" colspan="2">
                    <span class="is-size-6"
                      ><div style="padding-top: 15px">Colaborador</div></span
                    >
                  </td>
                  <td style="width: 4%" class="is-hidden-mobile"></td>
                  <td style="width: 86%;" class="is-hidden-mobile">
                    <GraphBullet
                      class="div-bullet"
                      :dataGraph="createdGraph('colaboradores', 'gperd')"
                      :cambio="dataLider.cambio"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;" class="has-text-right" colspan="2">
                    <span class="is-size-6">Autoevaluación</span>
                  </td>
                  <td style="width: 4%" class="is-hidden-mobile"></td>
                  <td style="width: 86%" class="is-hidden-mobile">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('autoevaluacion', 'gperd')"
                      :cambio="dataLider.cambio"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;">
                    <span class="is-size-6 has-text-right">Autoconciencia</span>
                  </td>
                  <td class="has-text-left">
                    <strong class="is-size-6 autoc-rango">{{
                      rangoAuto("gperd")
                    }}</strong>
                  </td>
                </tr>
              </table>

              <!--      V. Mobile      -->
              <div class="is-hidden-desktop">
                <div class="is-flex">
                  <i
                    v-if="estructura.gperd.length > 0"
                    v-on:click="showMore('gperd')"
                    class="material-icons has-text-dark"
                    style="cursor: pointer"
                    >{{
                      show.gperd
                        ? "remove_circle_outline"
                        : "add_circle_outline"
                    }}</i
                  >
                  <h1
                    class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                  >
                    Gestión Personas
                  </h1>
                </div>
                <div class="item-lider has-text-centered">
                  <span class="is-size-6"><div>Colaborador</div></span>
                </div>
                <div class="item-lider">
                  <GraphBullet
                    class="div-bullet"
                    style="margin-top: -15px"
                    :dataGraph="createdGraph('colaboradores', 'gperd')"
                    :cambio="dataLider.cambio"
                  />
                </div>
                <div class="item-lider has-text-centered">
                  <span class="is-size-6">Autoevaluación</span>
                </div>
                <div class="item-lider">
                  <GraphBullet
                    class="div-bullet"
                    style="margin-top: -15px"
                    :dataGraph="createdGraph('autoevaluacion', 'gperd')"
                    :cambio="dataLider.cambio"
                  />
                </div>
                <div class="item-lider has-text-centered"></div>
                <span class="is-size-6"
                  >Autoconciencia<strong class="is-size-6 autoc-rango">{{
                    rangoAuto("gperd")
                  }}</strong></span
                >
                <hr />
              </div>
            </div>
          </div>
          <div
            v-if="!generalContext.status"
            class="column is-5"
            style="margin-top: auto; margin-bottom: auto"
          >
            <div
              class="tags has-addons"
              style="margin-bottom: 0 !important;"
              v-if="dataLider.colaboradores"
            >
              <span
                class="tag is-medium"
                style="width: 100%"
                :class="`rango${dataLider.colaboradores.gperd.r}`"
              >
                {{ nombresRangos[dataLider.colaboradores.gperd.r] }}
              </span>
            </div>
            <span v-if="dataLider.colaboradores" class="is-size-7">{{
              calificaciones.gperd[dataLider.colaboradores.gperd.r]
            }}</span>
            <div
              class="is-flex"
              style="margin-top: 0.5rem"
              v-if="dataLider.colaboradores"
            >
              <span class="tag is-grey has-text-weight-bold"
                >Meta a proponerse en puntos
                {{ metas[dataLider.colaboradores.gperd.e.toFixed(0)] }}</span
              >
            </div>
          </div>
          <Transition name="Fade">
            <div
              v-if="generalContext.status"
              class="column is-2"
              style="margin: auto !important;"
            >
              <div class="ranking">
                <div
                  class="info"
                  style="width: 100%;"
                  v-tooltip.bottom="
                    `Posición actual frente a ${generalContext.headers
                      .clients || 0} de empresas`
                  "
                >
                  <span class="title-ranking card-position">
                    {{ getPositionVar("gperd") }}
                  </span>
                </div>
              </div>
            </div>
          </Transition>
          <Transition name="Fade">
            <div v-if="generalContext.status" class="column column-graph">
              <GraphChartJs :config="createdLineContext('gperd')" />
            </div>
          </Transition>
        </div>
        <div v-if="show.gperd" class="sub-items">
          <br />
          <div
            class="columns"
            v-for="(item, index) in estructura.gperd"
            :key="index"
          >
            <div :class="['column', { 'is-7': !generalContext.status }]">
              <div v-if="dataLider.colaboradores">
                <!--      V. Desktop      -->
                <table class="table-info is-hidden-mobile" style="width: 100%">
                  <tr>
                    <td colspan="4">
                      <div class="is-flex">
                        <h1
                          class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                        >
                          {{ nombres[item] }}
                        </h1>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;" class="has-text-right" colspan="2">
                      <span class="is-size-6"
                        ><div style="padding-top: 15px">Colaborador</div></span
                      >
                    </td>
                    <td style="width: 4%" class="is-hidden-mobile"></td>
                    <td style="width: 86%;" class="is-hidden-mobile">
                      <GraphBullet
                        class="div-bullet"
                        :dataGraph="createdGraph('colaboradores', item)"
                        :cambio="dataLider.cambio"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;" class="has-text-right" colspan="2">
                      <span class="is-size-6">Autoevaluación</span>
                    </td>
                    <td style="width: 4%" class="is-hidden-mobile"></td>
                    <td style="width: 86%" class="is-hidden-mobile">
                      <GraphBullet
                        class="div-bullet"
                        style="margin-top: -15px"
                        :dataGraph="createdGraph('autoevaluacion', item)"
                        :cambio="dataLider.cambio"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">
                      <span class="is-size-6 has-text-right"
                        >Autoconciencia</span
                      >
                    </td>
                    <td class="has-text-left">
                      <strong class="is-size-6 autoc-rango">{{
                        rangoAuto(item)
                      }}</strong>
                    </td>
                  </tr>
                </table>

                <!--      V. Mobile      -->
                <div class="is-hidden-desktop">
                  <div class="is-flex">
                    <h1
                      class="item-lider is-size-5 is-black has-text-right-desktop has-text-centered-mobile  has-text-weight-bold"
                    >
                      {{ nombres[item] }}
                    </h1>
                  </div>
                  <div class="item-lider has-text-centered">
                    <span class="is-size-6"><div>Colaborador</div></span>
                  </div>
                  <div class="item-lider">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('colaboradores', item)"
                      :cambio="dataLider.cambio"
                    />
                  </div>
                  <div class="item-lider has-text-centered">
                    <span class="is-size-6">Autoevaluación</span>
                  </div>
                  <div class="item-lider">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('autoevaluacion', item)"
                      :cambio="dataLider.cambio"
                    />
                  </div>
                  <div class="item-lider has-text-centered"></div>
                  <span class="is-size-6"
                    >Autoconciencia<strong class="is-size-6 autoc-rango">{{
                      rangoAuto(item)
                    }}</strong></span
                  >
                  <hr />
                </div>
              </div>
            </div>
            <div
              v-if="!generalContext.status"
              class="column is-5"
              style="margin-top: auto; margin-bottom: auto"
            >
              <div
                class="tags has-addons"
                style="margin-bottom: 0 !important;"
                v-if="dataLider.colaboradores"
              >
                <span
                  class="tag is-medium"
                  style="width: 100%"
                  :class="`rango${dataLider.colaboradores[item].r}`"
                >
                  {{ nombresRangos[dataLider.colaboradores[item].r] }}
                </span>
              </div>
              <span v-if="dataLider.colaboradores" class="is-size-7">{{
                calificaciones[item][dataLider.colaboradores[item].r]
              }}</span>
              <div
                class="is-flex"
                style="margin-top: 0.5rem"
                v-if="dataLider.colaboradores"
              >
                <span class="tag is-grey has-text-weight-bold"
                  >Meta a proponerse en puntos
                  {{ metas[dataLider.colaboradores[item].e.toFixed(0)] }}</span
                >
              </div>
            </div>
            <Transition name="Fade">
              <div
                v-if="generalContext.status"
                class="column is-2"
                style="margin: auto !important;"
              >
                <div class="ranking">
                  <div
                    class="info"
                    style="width: 100%;"
                    v-tooltip.bottom="
                      `Posición actual frente a ${generalContext.headers
                        .clients || 0} de empresas`
                    "
                  >
                    <span class="title-ranking card-position">
                      {{ getPositionVar(item) }}
                    </span>
                  </div>
                </div>
              </div>
            </Transition>
            <Transition name="Fade">
              <div v-if="generalContext.status" class="column column-graph">
                <GraphChartJs :config="createdLineContext(item)" />
              </div>
            </Transition>
          </div>
        </div>
      </div>
      <hr />
      <!--  Gestión Relaciones  -->
      <div style="margin-top: 30px; margin-bottom: 30px">
        <div class="columns">
          <div :class="['column', { 'is-7': !generalContext.status }]">
            <div v-if="dataLider.colaboradores">
              <!--      V. Desktop      -->
              <table class="table-info is-hidden-mobile" style="width: 100%">
                <tr>
                  <td colspan="4">
                    <div class="is-flex">
                      <i
                        v-if="estructura.reld.length > 0"
                        v-on:click="showMore('reld')"
                        class="material-icons has-text-dark"
                        style="cursor: pointer"
                        >{{
                          show.reld
                            ? "remove_circle_outline"
                            : "add_circle_outline"
                        }}</i
                      >
                      <h1
                        class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                      >
                        Gestión Relaciones
                      </h1>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;" class="has-text-right" colspan="2">
                    <span class="is-size-6"
                      ><div style="padding-top: 15px">Colaborador</div></span
                    >
                  </td>
                  <td style="width: 4%" class="is-hidden-mobile"></td>
                  <td style="width: 86%;" class="is-hidden-mobile">
                    <GraphBullet
                      class="div-bullet"
                      :dataGraph="createdGraph('colaboradores', 'reld')"
                      :cambio="dataLider.cambio"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;" class="has-text-right" colspan="2">
                    <span class="is-size-6">Autoevaluación</span>
                  </td>
                  <td style="width: 4%" class="is-hidden-mobile"></td>
                  <td style="width: 86%" class="is-hidden-mobile">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('autoevaluacion', 'reld')"
                      :cambio="dataLider.cambio"
                    />
                  </td>
                </tr>
                <tr>
                  <td style="width: 10%;">
                    <span class="is-size-6 has-text-right">Autoconciencia</span>
                  </td>
                  <td class="has-text-left">
                    <strong class="is-size-6 autoc-rango">{{
                      rangoAuto("reld")
                    }}</strong>
                  </td>
                </tr>
              </table>

              <!--      V. Mobile      -->
              <div class="is-hidden-desktop">
                <div class="is-flex">
                  <i
                    v-if="estructura.reld.length > 0"
                    v-on:click="showMore('reld')"
                    class="material-icons has-text-dark"
                    style="cursor: pointer"
                    >{{
                      show.reld ? "remove_circle_outline" : "add_circle_outline"
                    }}</i
                  >
                  <h1
                    class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile has-text-weight-bold"
                  >
                    Gestión Relaciones
                  </h1>
                </div>
                <div class="item-lider has-text-centered">
                  <span class="is-size-6"><div>Colaborador</div></span>
                </div>
                <div class="item-lider">
                  <GraphBullet
                    class="div-bullet"
                    style="margin-top: -15px"
                    :dataGraph="createdGraph('colaboradores', 'reld')"
                    :cambio="dataLider.cambio"
                  />
                </div>
                <div class="item-lider has-text-centered">
                  <span class="is-size-6">Autoevaluación</span>
                </div>
                <div class="item-lider">
                  <GraphBullet
                    class="div-bullet"
                    style="margin-top: -15px"
                    :dataGraph="createdGraph('autoevaluacion', 'reld')"
                    :cambio="dataLider.cambio"
                  />
                </div>
                <div class="item-lider has-text-centered"></div>
                <span class="is-size-6"
                  >Autoconciencia<strong class="is-size-6 autoc-rango">{{
                    rangoAuto("reld")
                  }}</strong></span
                >
                <hr />
              </div>
            </div>
          </div>
          <div
            v-if="!generalContext.status"
            class="column is-5"
            style="margin-top: auto; margin-bottom: auto"
          >
            <div
              class="tags has-addons"
              style="margin-bottom: 0 !important;"
              v-if="dataLider.colaboradores"
            >
              <span
                class="tag is-medium"
                style="width: 100%"
                :class="`rango${dataLider.colaboradores.reld.r}`"
              >
                {{ nombresRangos[dataLider.colaboradores.reld.r] }}
              </span>
            </div>
            <span v-if="dataLider.colaboradores" class="is-size-7">{{
              calificaciones.reld[dataLider.colaboradores.reld.r]
            }}</span>
            <div
              class="is-flex"
              style="margin-top: 0.5rem"
              v-if="dataLider.colaboradores"
            >
              <span class="tag is-grey has-text-weight-bold"
                >Meta a proponerse en puntos
                {{ metas[dataLider.colaboradores.reld.e.toFixed(0)] }}</span
              >
            </div>
          </div>
          <Transition name="Fade">
            <div
              v-if="generalContext.status"
              class="column is-2"
              style="margin: auto !important;"
            >
              <div class="ranking">
                <div
                  class="info"
                  style="width: 100%;"
                  v-tooltip.bottom="
                    `Posición actual frente a ${generalContext.headers
                      .clients || 0} de empresas`
                  "
                >
                  <span class="title-ranking card-position">
                    {{ getPositionVar("reld") }}
                  </span>
                </div>
              </div>
            </div>
          </Transition>
          <Transition name="Fade">
            <div v-if="generalContext.status" class="column column-graph">
              <GraphChartJs :config="createdLineContext('reld')" />
            </div>
          </Transition>
        </div>
        <div v-if="show.reld" class="sub-items">
          <br />
          <div
            class="columns"
            v-for="(item, index) in estructura.reld"
            :key="index"
          >
            <div :class="['column', { 'is-7': !generalContext.status }]">
              <div v-if="dataLider.colaboradores">
                <!--      V. Desktop      -->
                <table class="table-info is-hidden-mobile" style="width: 100%">
                  <tr>
                    <td colspan="4">
                      <div class="is-flex">
                        <h1
                          class="is-size-5 is-black has-text-left-desktop has-text-centered-mobile  has-text-weight-bold"
                        >
                          {{ nombres[item] }}
                        </h1>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;" class="has-text-right" colspan="2">
                      <span class="is-size-6"
                        ><div style="padding-top: 15px">Colaborador</div></span
                      >
                    </td>
                    <td style="width: 4%" class="is-hidden-mobile"></td>
                    <td style="width: 86%;" class="is-hidden-mobile">
                      <GraphBullet
                        class="div-bullet"
                        :dataGraph="createdGraph('colaboradores', item)"
                        :cambio="dataLider.cambio"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;" class="has-text-right" colspan="2">
                      <span class="is-size-6">Autoevaluación</span>
                    </td>
                    <td style="width: 4%" class="is-hidden-mobile"></td>
                    <td style="width: 86%" class="is-hidden-mobile">
                      <GraphBullet
                        class="div-bullet"
                        style="margin-top: -15px"
                        :dataGraph="createdGraph('autoevaluacion', item)"
                        :cambio="dataLider.cambio"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td style="width: 10%;">
                      <span class="is-size-6 has-text-right"
                        >Autoconciencia</span
                      >
                    </td>
                    <td class="has-text-left">
                      <strong class="is-size-6 autoc-rango">{{
                        rangoAuto(item)
                      }}</strong>
                    </td>
                  </tr>
                </table>

                <!--      V. Mobile      -->
                <div class="is-hidden-desktop">
                  <div class="is-flex">
                    <h1
                      class="item-lider is-size-5 is-black has-text-right-desktop has-text-centered-mobile  has-text-weight-bold"
                    >
                      {{ nombres[item] }}
                    </h1>
                  </div>
                  <div class="item-lider has-text-centered">
                    <span class="is-size-6"><div>Colaborador</div></span>
                  </div>
                  <div class="item-lider">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('colaboradores', item)"
                      :cambio="dataLider.cambio"
                    />
                  </div>
                  <div class="item-lider has-text-centered">
                    <span class="is-size-6">Autoevaluación</span>
                  </div>
                  <div class="item-lider">
                    <GraphBullet
                      class="div-bullet"
                      style="margin-top: -15px"
                      :dataGraph="createdGraph('autoevaluacion', item)"
                      :cambio="dataLider.cambio"
                    />
                  </div>
                  <div class="item-lider has-text-centered"></div>
                  <span class="is-size-6"
                    >Autoconciencia<strong class="is-size-6 autoc-rango">{{
                      rangoAuto(item)
                    }}</strong></span
                  >
                  <hr />
                </div>
              </div>
            </div>
            <div
              v-if="!generalContext.status"
              class="column is-5"
              style="margin-top: auto; margin-bottom: auto"
            >
              <div
                class="tags has-addons"
                style="margin-bottom: 0 !important;"
                v-if="dataLider.colaboradores"
              >
                <span
                  class="tag is-medium"
                  style="width: 100%"
                  :class="`rango${dataLider.colaboradores[item].r}`"
                >
                  {{ nombresRangos[dataLider.colaboradores[item].r] }}
                </span>
              </div>
              <span v-if="dataLider.colaboradores" class="is-size-7">{{
                calificaciones[item][dataLider.colaboradores[item].r]
              }}</span>
              <div
                class="is-flex"
                style="margin-top: 0.5rem"
                v-if="dataLider.colaboradores"
              >
                <span class="tag is-grey has-text-weight-bold"
                  >Meta a proponerse en puntos
                  {{ metas[dataLider.colaboradores[item].e.toFixed(0)] }}</span
                >
              </div>
            </div>
          </div>
          <Transition name="Fade">
            <div
              v-if="generalContext.status"
              class="column is-2"
              style="margin: auto !important;"
            >
              <div class="ranking">
                <div
                  class="info"
                  style="width: 100%;"
                  v-tooltip.bottom="
                    `Posición actual frente a ${generalContext.headers
                      .leaders || 0} de líderes`
                  "
                >
                  <span class="title-ranking card-position">
                    {{ getPositionVar(item) }}
                  </span>
                </div>
              </div>
            </div>
          </Transition>
          <Transition name="Fade">
            <div v-if="generalContext.status" class="column column-graph">
              <GraphChartJs :config="createdLineContext(item)" />
            </div>
          </Transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphBullet from "../../dashboard/GraphBullet.vue";
import GraphChartJs from "../../dashboard/GraphChartJs.vue";
/* import Graph from "../../dashboard/Graph.vue"; */
import { mapState } from "vuex";
import json from "../calificacionLider.json";
import MenuInterpretacionesLider from "../MenuInterpretacionesLider.vue";

export default {
  data() {
    return {
      nameLider: "",
      dependProceso: [],
      estructura: {
        categorias: ["liderT", "cond", "resuld", "dsmd", "gperd", "reld"],
        cond: [],
        resuld: ["cambiod", "logrod"],
        dsmd: ["humid", "autogd"],
        gperd: [],
        reld: ["cefectivad", "asertivad", "cercaniad", "rad"],
        liderT: [],
      },
      rangosAuto: {
        0: "Sin resultados",
        1: "Alta",
        2: "Media",
        3: "Bajo",
      },
      nombres: {
        cond: "Gestión del Conocimiento",
        resuld: "Gestión de Resultados",
        cambiod: "Cambio y Toma de Decisiones",
        logrod: "Logro",
        dsmd: "Gestión de Sí Mismo",
        humid: "Humildad",
        autogd: "Autogestión",
        gperd: "Gestión de Personas",
        reld: "Gestión de Relaciones",
        cefectivad: "Comunicación Efectiva",
        asertivad: "Asertividad",
        cercaniad: "Cercanía",
        rad: "Retroalimentación",
        liderT: "Líder PHD",
      },
      nombresRangos: [
        "Sin Resultados",
        "Líder con prioridad de intervención",
        "Líder con oportunidad de mejora",
        "Líder en desarrollo",
        "Líder competente",
        "Líder experta(o)",
        "Líder PHD",
      ],
      calificaciones: json.calificaciones,
      metas: json.metas,
      show: {
        cond: false,
        resuld: false,
        dsmd: false,
        gperd: false,
        reld: false,
      },
    };
  },
  props: {
    dataLider: {
      type: Object,
    },
    generalContext: {
      type: Object,
      required: true,
    },
  },
  methods: {
    createdPie(subgroup) {
      if (this.dataLideres.countRange) {
        let data = this.dataLideres.countRange[subgroup];
        let labelsRange = this.nombresRangos;

        let pie = {
          data: [data],
          labels: labelsRange,
          series: [],
          colors: [
            "#bebdbd",
            "#f4cdcd",
            "#facca5",
            "#fff2cc",
            "#d9ead3",
            "#a2c4c9",
            "#c8d9f7",
          ],
          options: {
            legend: { display: false, position: "right" },
            responsive: true,
            resizeDelay: 0,
          },
          typeGraphic: "pie",
        };
        return pie;
      }
    },
    createdGraph(group, subgroup) {
      try {
        if (this.dataLider) {
          const data = this.dataLider[group][subgroup];
          let type = "e";
          let size = 0;
          let showTicks = true;
          let target = false;
          let dataComp;

          if (group === "autoevaluacion") {
            size = 20;
            showTicks = true;
          } else {
            size = 26;
            showTicks = false;
          }

          if (this.dataLider.hasOwnProperty("processComp")) {
            dataComp = this.dataLider.processComp[group][subgroup][type];
            target = true;
          }

          data[type] = this.nZero(data[type]);

          let dataGraph = {
            data: [
              {
                type: "indicator",
                mode: "number+gauge+delta" /* number+gauge+delta */,
                target: target,
                value: data[type],
                domain: { x: [0, 1], y: [0.2, 0.8] },
                delta: {
                  reference: target ? dataComp : data[type],
                  font: { size: 12 },
                  valueformat: ".2f",
                },
                number: {
                  font: { size: size },
                  valueformat: ".2f",
                } /* suffix: "%" agregar texto al final del valor */,
                gauge: {
                  shape: "bullet",
                  axis: { range: [0, 100], showticklabels: showTicks },
                  threshold: {
                    line: { color: "black", width: 2 },
                    thickness: target ? 0.75 : 0,
                    value: dataComp || 0,
                  },
                  steps: [
                    { range: [0, 50], color: "#f4cdcd" },
                    { range: [50, 60], color: "#facca5" },
                    { range: [60, 70], color: "#fff2cc" },
                    { range: [70, 80], color: "#d9ead3" },
                    { range: [80, 90], color: "#a2c4c9" },
                    { range: [90, 100], color: "#c8d9f7" },
                  ],
                  bar: { color: "black" },
                  bordercolor: "white",
                },
              },
            ],
            options: {
              config: {
                responsive: true,
                displayModeBar: false,
              },
              layout: {
                height: 60,
                margin: {
                  l: 15,
                  r: 15,
                  b: 11,
                  t: 5,
                  pad: 1,
                },
              },
              tooltip: {
                text: `Valor: ${data[type]}`,
              },
            },
          };
          return dataGraph;
        }
      } catch (err) {
        console.log(err);
      }
    },
    createdLineContext(group) {
      if (!group && !Object.keys(this.generalContext.data).length) return null;

      const position = this.dataLider.colaboradores[group].e;
      const context = Object.entries(
        this.generalContext.data[`${group.toLowerCase()}_e`],
      );
      const labels = context.map(([k, v]) => parseInt(k));
      const colors = labels.map((v) => this.getInfoRange(v));

      return {
        type: "line",
        data: {
          datasets: [
            {
              label: "Empresas",
              data: context.map(([k, v]) => {
                return { x: Number(k), y: Number(v) };
              }),
              fill: false,
              color: colors,
              backgroundColor: colors,
              borderColor: "rgb(75, 192, 192)",
              tension: 0.2,
              pointRadius: function(context) {
                const dataIndex = context.dataIndex;
                const dataset = context.dataset.data;

                if (dataIndex === 0 || dataIndex === dataset.length - 1) {
                  return 4;
                }

                const value = dataset[dataIndex].y;
                return value === 0 ? 0 : 4;
              },
            },
          ],
        },
        options: {
          tooltips: {
            callbacks: {
              title: function(tooltipItem, data) {
                console.log(tooltipItem);

                const value = tooltipItem[0].label;
                const nextStep = parseInt(value) + 5; // 5 es el stepSize de los ticks en xAxes
                return `${this.getInfoRange(
                  value,
                  "title",
                )} (${value} al ${nextStep})`;
              }.bind(this),
            },
          },
          legend: { display: false, position: "right" },
          responsive: true,
          maintainAspectRatio: false,
          resizeDelay: 0,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  padding: 0,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            xAxes: [
              {
                type: "linear",
                ticks: {
                  stepSize: 5,
                  min: Math.min(...labels),
                  max: Math.max(...labels),
                  autoSkip: false,
                  display: false,
                },
                gridLines: {
                  display: false,
                },
              },
            ],
          },
          annotation: {
            annotations: [
              {
                id: "a-line-1",
                type: "line",
                mode: "vertical",
                scaleID: "x-axis-0",
                value: position.toFixed(2),
                borderColor: "rgba(0, 0, 0, 0.5)",
                borderWidth: 2,
                labelEnabled: true,
                imagenStatus: false,
                label: {
                  enabled: true,
                  content: ".",
                  position: "top",
                  fontColor: "#FFFFFF",
                  fontSize: 14,
                  fontStyle: "bold",
                  fontFamily: "Arial",
                  backgroundColor: "rgba(0, 0, 0, 0)",
                  xPadding: 10,
                  yPadding: 0,
                  yAdjust: 0,
                  cornerRadius: 5,
                },
              },
            ],
          },
        },
        plugins: [
          {
            beforeDraw: (chart) => {
              const ctx = chart.chart.ctx;

              const xScale = chart.scales["x-axis-0"];
              const yScale = chart.scales["y-axis-0"];

              xScale.ticks.forEach((tick, index) => {
                const tickX = xScale.getPixelForTick(index);
                ctx.fillStyle = this.getInfoRange(tick);
                const tickWidth =
                  index < xScale.ticks.length - 1
                    ? xScale.getPixelForTick(index + 1) - tickX
                    : xScale.right - tickX;

                ctx.fillRect(tickX, yScale.bottom, tickWidth, 20);
              });
            },
            afterDatasetsDraw: (chart) => {
              const ctx = chart.ctx;
              const sizeImg = 30;
              // Recorre las anotaciones y dibuja la imagen
              Object.entries(chart.annotation.elements).forEach(
                ([key, annotation]) => {
                  if (annotation.options.type !== "line") return;

                  const model = annotation._model;

                  if (!model || isNaN(model.x1) || isNaN(model.y1)) return;

                  if (annotation.options.imagenStatus) {
                    ctx.drawImage(
                      annotation.options.img,
                      model.x1 - sizeImg / 2,
                      model.y1 - 8,
                      sizeImg,
                      sizeImg,
                    );
                  }

                  // Dibuja una imagen junto al texto de la anotación
                  const img = new Image();
                  img.src = require("@/assets/icons/user-default.png");
                  img.onload = () => {
                    annotation.options.img = img;
                    ctx.drawImage(
                      img,
                      model.x1 - sizeImg / 2,
                      model.y1 - 8,
                      sizeImg,
                      sizeImg,
                    ); // Dibuja la imagen en el gráfico
                    annotation.options.imagenStatus = true;
                  };
                },
              );
            },
          },
        ],
      };
    },
    getInfoRange(value, type = "color") {
      const ranges = [
        {
          range: [0, 50],
          color: "#f4cdcd",
          title: "Líder con prioridad de intervención",
        },
        {
          range: [50, 60],
          color: "#facca5",
          title: "Líder con oportunidad de mejora",
        },
        { range: [60, 70], color: "#fff2cc", title: "Líder en desarrollo" },
        { range: [70, 80], color: "#d9ead3", title: "Líder competente" },
        { range: [80, 90], color: "#a2c4c9", title: "Líder experta(o)" },
        { range: [90, 100], color: "#c8d9f7", title: "Líder PHD" },
      ];
      const rangeObject = ranges.find(({ range }) => value < range[1]);
      return rangeObject ? rangeObject[type] : null;
    },
    getPositionVar(subgroup) {
      const value = this.dataLider.colaboradores[subgroup].e;
      if (value === null) return "-";
      subgroup = subgroup.toLowerCase();
      const position = this.generalContext.headers.ranking[
        `avg_${subgroup}_e`
      ].filter((item) => item[`avg_${subgroup}_e`] > value).length;
      return position + 1;
    },
    rangoAuto(subgroup) {
      if (this.dataLider.autoconciencia) {
        let r = this.dataLider.autoconciencia[subgroup].r;
        return this.rangosAuto[r];
      }
    },
    nZero(n) {
      if (n < 0) {
        return 0;
      }
      return n;
    },
    showMore(gruop) {
      this.show[gruop] ? (this.show[gruop] = false) : (this.show[gruop] = true);
    },
  },
  computed: {
    ...mapState(["empresa", "isOculto"]),
  },
  watch: {
    isOculto(nv, v) {
      if (nv) {
        this.show.menu = false;
      }
    },
  },
  components: {
    GraphBullet,
    GraphChartJs,
    MenuInterpretacionesLider,
  },
};
</script>

<style scoped>
.is-black {
  color: black;
}

.is-green {
  color: green;
}

.is-primary {
  color: #134f5c !important;
}

.is-red {
  color: rgba(243, 50, 50, 0.94);
}

.text-justify {
  text-align: justify !important;
  text-justify: inter-word !important;
}

.autoc-rango {
  padding-left: 10px;
}

.item-lider {
  margin-top: 10px;
  margin-bottom: 15px;
}

.material-icons {
  margin-right: 10px;
  margin-top: 2px;
}

.sub-items {
  padding-left: 25px;
  border-left: #f5f5f5 solid 3px;
}

.icon i {
  margin-right: 0 !important;
  margin-top: 0 !important;
}

/* Backgrounds */

.rango1 {
  background-color: #f4cdcd !important;
  color: gray;
}

.rango2 {
  background-color: #facca5 !important;
  color: gray;
}

.rango3 {
  background-color: #fff2cc !important;
  color: gray;
}

.rango4 {
  background-color: #d9ead3 !important;
  color: gray;
}

.rango5 {
  background-color: #a2c4c9 !important;
  color: white;
}

.rango6 {
  background-color: #c8d9f7 !important;
  color: white;
}

.rango0 {
  background-color: rgba(175, 174, 174, 0.81);
}

@media (min-width: 769px) {
  .div-bullet {
    width: 380px !important;
  }

  .div-pie {
    width: 185px !important;
  }
}

.column-graph {
  margin: 0 !important;
  max-height: 150px;
}

.ranking {
  display: flex;
  justify-content: start;
  gap: 15px;
}

.ranking-only-icon {
  align-items: center;
  flex-direction: column;
  justify-content: center !important;
}

.ranking .info {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ranking .title-ranking {
  color: #363636;
  text-align: center;
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.125;
}
.card-position {
  width: 100px;
  height: 100px;
  color: #4a4a4a;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ranking .subtitle-ranking {
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/ResultadoLider/ResulLiderParte1.vue